import { TurnPortfolioResource } from '../../types/TurnPortfolioResource';
import { TurnActionType, TurnPortfolioActions } from './TurnActions';

export type TurnPortfolioState = {
  turnPortfolios: TurnPortfolioResource[];
  loading: boolean;
  error: boolean;
};

export const initialTurnPortfolioState: TurnPortfolioState = {
  turnPortfolios: [],
  loading: false,
  error: false,
};

export const turnPortfolioReducer = (
  state: TurnPortfolioState = initialTurnPortfolioState,
  action: TurnPortfolioActions,
): TurnPortfolioState => {
  switch (action.type) {
    case TurnActionType.TURN_PORTFOLIO_LOADING:
      return {
        turnPortfolios: [],
        loading: true,
        error: false,
      };
    case TurnActionType.TURN_PORTFOLIO_LOADED:
      return {
        turnPortfolios: action.payload,
        loading: false,
        error: false,
      };
    case TurnActionType.TURN_PORTFOLIO_ERROR:
      return {
        turnPortfolios: [],
        loading: false,
        error: true,
      };
    case TurnActionType.TURN_PORTFOLIO_REMOVE:
      return {
        turnPortfolios: [],
        loading: false,
        error: false,
      };
    default:
      return state;
  }
};
